import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestCancelOrder, requestCancelAllBets } from '../../store/betPlacing/betPlacing.thunks';
import { requestOpenBets } from '../../store/openBets/openBets.thunks';

export const connectOpenBets = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      timeSettings: state.timeSettings,
      auth: state.auth
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestOpenBets,
      requestCancelOrder,
      requestCancelAllBets,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
